import axios from "axios";
import { base_url, BASE_URL } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const uploadImg = async (data) => {
  const response = await axios.post(`${BASE_URL}images/add-images`, data, config);
  //console.log(response.data);
  return response.data;
};

const deleteImg = async (id) => {
  const response = await axios.delete(
    `${base_url}upload/delete-image/${id}`,
    config
  );
  //console.log(response.data);
  return response.data;
};

const uploadService = {
  uploadImg,
  deleteImg,
};

export default uploadService;
